import { StyleSheet, View } from "react-native";

import { Orientation } from "../../types";
import React from "react";

interface IProps {
  type?: Orientation;
  space: number;
}

const SSpacer: React.FC<IProps> = ({ type = Orientation.Vertical, space }) => {
  const height = type === Orientation.Vertical ? space : 0;
  const width = type === Orientation.Vertical ? 0 : space;

  return (
    <View
      style={{
        height,
        width,
      }}
    />
  );
};

const styles = StyleSheet.create({
  container: {},
});

export default SSpacer;
